/**
 * Mock implementation of Node.js events module for browser environment
 */

export class EventEmitter {
  private _events: Record<string, Function[]>;
  
  constructor() {
    this._events = {};
  }
  
  on(event: string, listener: Function) {
    console.log(`[MockEvents] on: ${event}`);
    if (!this._events[event]) {
      this._events[event] = [];
    }
    this._events[event].push(listener);
    return this;
  }
  
  emit(event: string, ...args: any[]) {
    console.log(`[MockEvents] emit: ${event}`);
    if (!this._events[event]) return false;
    this._events[event].forEach(listener => listener(...args));
    return true;
  }
  
  removeListener(event: string, listener: Function) {
    console.log(`[MockEvents] removeListener: ${event}`);
    if (!this._events[event]) return this;
    this._events[event] = this._events[event].filter(l => l !== listener);
    return this;
  }
  
  addListener(event: string, listener: Function) {
    return this.on(event, listener);
  }
  
  once(event: string, listener: Function) {
    const onceWrapper = (...args: any[]) => {
      this.removeListener(event, onceWrapper);
      listener(...args);
    };
    this.on(event, onceWrapper);
    return this;
  }
  
  removeAllListeners(event?: string) {
    if (event) {
      delete this._events[event];
    } else {
      this._events = {};
    }
    return this;
  }
}

// Export all events classes and functions
export default {
  EventEmitter
};
